import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-memory-banner-card',
  templateUrl: './memory-banner-card.component.html',
  styleUrls: ['./memory-banner-card.component.css']
})
export class MemoryBannerCardComponent implements OnInit {
@Input() isMemoryCard:any = false;
  constructor(public router: Router) { }

  ngOnInit(): void {
  }
  navigateToCardofTheDay(){
    if(this.isMemoryCard){
      this.router.navigate([`selfLearn-V2/memory-card`]);
    }else{
      localStorage.setItem('previousScreen','selfLearn-V2/my-library')
      this.router.navigate([`selfLearn-V2/card-of-the-day`]);
    }
   
  }
}
